import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/GasReturnTanks/Get`, payload),
    GetById: (payload) => Repository.post(`/api/GasReturnTanks/GetById`, payload),
    Add: (payload) => Repository.post(`/api/GasReturnTanks/Add`, payload),
    Edit: (payload) => Repository.post(`/api/GasReturnTanks/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/GasReturnTanks/Delete`, payload),
}
